var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.1 42.45-3.35-5.7-6.5-1.3.65-6.55L4.7 24l4.2-4.9-.65-6.5 6.5-1.35 3.35-5.7 5.9 2.6 5.9-2.6 3.4 5.7 6.5 1.35-.7 6.5 4.2 4.9-4.2 4.9.7 6.55-6.5 1.3-3.4 5.7-5.9-2.6Zm.7-2L24 38.3l5.25 2.15 3.15-4.9 5.65-1.35-.55-5.85L41.4 24l-3.9-4.4.55-5.85-5.65-1.3-3.15-4.9L24 9.7l-5.25-2.15-3.15 4.9-5.65 1.3.55 5.85L6.6 24l3.9 4.35-.55 5.9 5.65 1.3ZM24 24Zm-2.1 5.5 9.9-9.85-1.15-1.05-8.75 8.7-4.55-4.65-1.15 1.2Z"
  })));
};
export default SvgVerified;